import { render, staticRenderFns } from "./BlacklistedContacts.vue?vue&type=template&id=4d634f74"
import script from "./BlacklistedContacts.vue?vue&type=script&lang=js"
export * from "./BlacklistedContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports